export const SHAPE = 'rect';
export const LAYOUT = 'vertical';
export const COLOR = 'black';
export const LABEL = 'paypal';
export const BORDER_RADIUS = 0;
export const HEIGHT = 43;
export const AUTHORIZE = 'authorize';
export const BUTTONS = 'buttons';
export const DATA_PAGE_TYPE = 'product-details';
export const PAYPAL_COMPONENT_LOADER_HEIGHT = 2;
